import { ErrorMessage } from 'components/ErrorBoundary/ErrorMessage'
import { createContext } from 'lib/createContext'
import { useWorkerProfile } from 'queries/worker'
import { PropsWithChildren, useMemo } from 'react'
import { Loading } from 'ui'

export interface WorkerProfileContextValues {
  state: NonNullable<ReturnType<typeof useWorkerProfile>['data']>
  actions: {
    invalidate: () => void
  }
}

const [WorkerProfileContext, useWorkerProfileContext] =
  createContext<WorkerProfileContextValues>({
    name: 'WorkerProfileContext',
    strict: true,
  })

export const WorkerProfileProvider = (
  props: PropsWithChildren<{ workerId: number }>
) => {
  const { data, isLoading, isError, error, refetch } = useWorkerProfile(
    props.workerId
  )

  const values = useMemo(() => {
    if (data) {
      return {
        state: {
          ...data,
          profile: {
            ...data.worker,
            address: null,
            firstActive: null,
          },
        },
        actions: {
          invalidate: refetch,
        },
      }
    }
  }, [data, isLoading])

  if (isLoading) {
    return <Loading />
  }

  if (isError || !values) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(error) /* eslint-disable-line no-console */
    }

    return <ErrorMessage message={error?.message} />
  }

  return (
    <WorkerProfileContext.Provider value={values}>
      {props.children}
    </WorkerProfileContext.Provider>
  )
}

export { useWorkerProfileContext }
